
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Added dark-themed components to Figma `}<a parentName="p" {...{
        "href": "https://www.figma.com/community/file/852558784352181868"
      }}>{`Component Sticker Sheet`}</a>{` and a `}<a parentName="p" {...{
        "href": "https://www.figma.com/community/plugin/971482182464094790"
      }}>{`plugin`}</a>{` to quickly change the theme for your designs, new components for collapsible App Bars across all frameworks, updated dark theme and internationalization support in the Authentication workflows, updated documentation site content, and more.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;